import { render, staticRenderFns } from "./VAuctionForm.vue?vue&type=template&id=0bbad71c"
import script from "./VAuctionForm.vue?vue&type=script&lang=js"
export * from "./VAuctionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports